import { DialogDescription } from "@radix-ui/react-dialog";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { useTranslation } from "react-i18next";

import { useUnsavedChanges } from "~/providers/unsaved-changes-provider";
import { useSectionStore } from "~/stores/use-section-store";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { ScrollArea } from "../ui/scroll-area";
import SectionForm from "./section-form";

export default function SectionDialog() {
  const { t } = useTranslation("common");
  const {
    sectionDialogOpen,
    selectedSection,
    setSelectedSection,
    setSectionDialogOpen,
  } = useSectionStore();

  const { checkUnsavedChanges } = useUnsavedChanges();

  const handleDialog = (open: boolean, force?: boolean) => {
    if (open === false) {
      if (force !== true) {
        const result = checkUnsavedChanges();
        if (result === true) return;
      }
      setSelectedSection(undefined);
    }
    setSectionDialogOpen(open);
  };
  return (
    <Dialog open={sectionDialogOpen} onOpenChange={handleDialog}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("section")}</DialogTitle>
          <VisuallyHidden>
            <DialogDescription></DialogDescription>
          </VisuallyHidden>
        </DialogHeader>
        <ScrollArea className="max-h-[80vh] p-4 max-w-lg w-full">
          <SectionForm
            section={selectedSection}
            onClose={() => handleDialog(false)}
          />
        </ScrollArea>
        <DialogFooter>
          <Button
            variant="success"
            className="w-full"
            form="section-form"
            type="submit"
          >
            {selectedSection ? t("update") : t("create")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
